@import "/src/variables/color";
@import "/src/variables/font_size";
@import "/src/variables/font";
@import "/src/variables/border-radius";
@import "/src/variables/shadow";
@import "/src/variables/tokens";

.panel {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: $space-16 $space-8;
  // Theme Studio dropdown menu vars; fallbacks = shipped.
  background: $zv-menu-bg--White;
  border: $zv-menu-border--border-width-solid-rgba-Neutral-Darkest-0-1;
  border-radius: $zv-menu-radius--border-radius-xl;
  box-shadow: $zv-menu-shadow--shadow-new-lg;
}

.hug {
  width: fit-content;
  min-width: 150px;
}

.row {
  display: flex;
  align-items: center;
  gap: $space-10;
  width: 100%;
  height: 36px;
  padding: 0 $space-12;
  border: none;
  outline: none;
  background: transparent;
  border-radius: $border-radius-sm;
  cursor: pointer;
  text-align: left;
  text-decoration: none;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background: $zv-menu-hover-bg--rgba-Neutral-Darkest-0-05;
  }
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  color: $zv-icon--Neutral-Darkest;
}

.label {
  color: $zv-text-primary--Neutral-Darker;
  font-family: $font-primary;
  font-size: $font-size-h14;
  font-weight: $fw-normal;
  line-height: $line-height-ratio-1;
  white-space: nowrap;
}

.danger {
  .icon,
  .label {
    color: $Error-Text;
  }
}
